const firebaseConfig = {
    apiKey: "AIzaSyAfksDmmlo4OGq1rcmBW_xlZnmBfDJX6ks",
    authDomain: "gucschedule.firebaseapp.com",
    projectId: "gucschedule",
    storageBucket: "gucschedule.appspot.com",
    messagingSenderId: "621973797621",
    appId: "1:621973797621:web:56ac02c13ae4653521a3bc",
    measurementId: "G-LB7NRX352B",
};

export { firebaseConfig };
